import Vue from "vue";
import ElementUI from "element-ui";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import api from "./plugins/http/api.js";
import message from "./plugins/message";
import pc_message from "./plugins/pc-message";
import { isPC } from "./utils";

import "element-ui/lib/theme-chalk/index.css";

import "./plugins/lang.js";
import "@/assets/css/iconfont.css"; //图标库引入
import "@/assets/css/common.scss"; //公共样式引入

if (isPC()) {
  import("./utils/rem");
  import("./components/pc");
} else {
  import("./components/mobile");
}

import { tongji } from "./plugins/tongji.js";
import i18n from "./i18n";

Vue.prototype.$api = api;
Vue.config.productionTip = false;
Vue.prototype.$tongji = tongji;
Vue.prototype.$msg = message;
Vue.prototype.$pc_msg = pc_message;

Vue.use(ElementUI);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
